import Repository from "./Repository";

const GET_ALL_DOWNLOADS = "/Download/getAllDownload";

export default {
  getAllDownloads() {
    return Repository.get(GET_ALL_DOWNLOADS);
  },
};
